import { FilterTag } from './filter-tag';
import { emptySidebarStyles } from './styles';
import type { SuggestionProps } from './types';

export function SuggestionType({ blindingFilters }: SuggestionProps) {
  const style = emptySidebarStyles();

  if (!blindingFilters.alertTypeList.isTooRestricted) {
    return null;
  }

  return (
    <div className={style.suggestion()}>
      <span>
        Clear the <FilterTag text="Alert Type" /> filter to ensure you're not
        missing any relevant alerts.
      </span>
    </div>
  );
}
